import React, {useCallback, useEffect} from 'react';
import { isEmpty } from 'lodash';
import css from './Kudos.css';
import moment from 'moment';
import useStarfishAPI from "../hooks/useStarfishAPI";
import MaterialIcon from "../SF/MaterialIcon";
import PropTypes from "prop-types";
import {getStaffMemberConnectionProfileUrl} from "../utils/successNetworkURL";
import commonWidgetCSS from "./CommonWidget.css";

// Endpoint URL
const URL = `../student/getKudosSummary.html`;

/**
 * Kudos widget for the Student Dashboard
 * @param {object} props Component props
 * @returns {React.Component} a React component containing content of Kudos Student Dashboard widget.
 */
const Kudos = (props) => {
  const [response, callAPI] = useStarfishAPI();
  const kudosData = response.success && !isEmpty(response.data.kudos) && response.data.kudos;
  const fetchKudos = useCallback(() => {
    callAPI(URL, {
      method: "GET",
      headers: {
        Pragma: "no-cache",
        "Cache-Control": "no-cache",
        Expires: "-1"
      }
    });
  }, []);

  useEffect(() => {
    if ( !isEmpty(kudosData) ) props.setCount(kudosData.length);
  }, [kudosData]);

  useEffect(() => {
    fetchKudos();
  }, [fetchKudos]);

  if (!kudosData) return null;
  return(
    <div className={css.content} data-testid='kudos'>
      {kudosData.map((kudo, index) => {
        return <div className={`${css.contentInner} ${commonWidgetCSS.container}`}  key={index}>
          <div>
            <img src="../images/starfish/Happy_starfish_green.png"
                 aria-hidden="true"
                 className={css.image}/>
          </div>
          <div className={css.info} data-role='kudosInfoContainer'>
            <div className={css.name}>{kudo.name}</div>
            <div className={css.row}>
              <MaterialIcon aria-hidden="true" icon='person'/>
              <div className={css.text}>
                Sent by <a className={css['kudos-link']} href={getStaffMemberConnectionProfileUrl(kudo.raiser.id)}>{kudo.raiser.name}</a> on {moment(kudo.raisedDate).format('MM-DD-YYYY')}
              </div>
            </div>
            {kudo.section && <div className={css.row} data-testid='courseInfo'>
              <img src="../images/starfish/icons/starfish_book.png"
                   aria-hidden="true"
                   className={css.icon}/>
              <div className={css.courseName}>{kudo.section.name} ({kudo.section.cmsCourseId})</div>
            </div>}
            {kudo.raiseNotes && <div className={css.row} data-testid='notes'>
              <MaterialIcon aria-hidden="true" icon='message'/>
              <div className={css.text}>{(kudo.raiseNotes).replace(/<[^>]*>/g, ' ').trim()}</div>
            </div>}
          </div>
        </div>
      })}
    </div>
  );
};

Kudos.propTypes = {
  setCount: PropTypes.func.isRequired,
};

export default Kudos;
